import { DateTime } from 'luxon';
import { SpinnerService } from 'src/app/base/spinner/spinner.service';
import { ModalService } from './../../../base/shared/modal/modal.service';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import {
  ClientDTO,
  ExportInterfaceConfigTemplateDTO,
  ExportInterfaceConfigurationDetailsDTO,
  ExportInterfaceConfigurationDTO,
  ExportInterfaceConfigurationFileProcessType,
  ExportInterfaceConfigurationFilterDTO,
  ExportInterfaceConfigurationTransferType,
  ExportInterfaceConfigurationType,
  SalesPersonCodeClient,
  UpdateExportInterfaceConfigurationDTO,
} from 'src/app/base/models/models.swagger.generated';
import { ConfigurationFormCoordinatorService } from '../shared/configuration-forms/configuration-form-coordinator.service';
import { ConfigurationOverviewComponent } from '../shared/configuration-overview/configuration-overview.component';
import { ErrorType } from '../../../core/routing/error-types';
import { ToastService } from '../../../base/services/toast.service';
import { ConfigurationsService } from './configurations.service';
import { DialogComponent, TooltipModule, DialogModule } from '@syncfusion/ej2-angular-popups';
import { ConfigurationTemplatesService } from '../configuration-templates/configuration-templates.service';
import { AuthService } from '../../../base/services/auth.service';
import { merge, Observable, of, Subject, throwError } from 'rxjs';
import { catchError, filter, mapTo, startWith, switchMap, takeUntil, tap } from 'rxjs/operators';
import { CountryISO2 } from '../../../base/shared/countryISO2-enum';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { MultiSelectItem } from '../../../base/shared/multi-select-filter/multi-select-item';
import { MultiSelectFilterType } from '../../../base/shared/multi-select-filter/multi-select-filter-type';
import { ConfigurationTemplatesOverviewComponent } from '../shared/configuration-templates-overview/configuration-templates-overview.component';
import { ConfigurationFormsOverviewComponent } from '../shared/configuration-forms/configuration-forms-overview/configuration-forms-overview.component';
import { MultiSelectFilterComponent } from '../../../base/shared/multi-select-filter/multi-select-filter.component';
import { EnumDropDownListComponent } from '../../../base/shared/enum-drop-down-list/enum-drop-down-list.component';
import { SearchFieldComponent } from '../../../base/shared/search-field/search-field.component';
import { NgClass } from '@angular/common';
import { ClientAutocompleteComponent } from '../../../base/shared/client-autocomplete/client-autocomplete.component';
import { TitleBarComponent } from '../../../base/shared/title-bar/title-bar.component';
import { NavigationEnd, Router } from '@angular/router';
import { configurationsExpConfRoute } from 'src/app/core/routing/route-names';
import * as pages from '../../../core/routing/page-names';
import { UrlHelper } from 'src/app/base/shared/url-helper';

@Component({
    selector: 'app-configurations',
    templateUrl: './configurations.component.html',
    styleUrls: ['./configurations.component.scss'],
    imports: [
    TitleBarComponent,
    ClientAutocompleteComponent,
    NgClass,
    ReactiveFormsModule,
    SearchFieldComponent,
    EnumDropDownListComponent,
    MultiSelectFilterComponent,
    ConfigurationOverviewComponent,
    ConfigurationFormsOverviewComponent,
    TooltipModule,
    DialogModule,
    ConfigurationTemplatesOverviewComponent,
    TranslateModule
]
})
export class ConfigurationsComponent implements OnInit, OnDestroy {

  @ViewChild(ConfigurationOverviewComponent)
  configurationOverviewComponent: ConfigurationOverviewComponent;

  @ViewChild(ConfigurationFormsOverviewComponent)
  configurationFormsOverviewComponent: ConfigurationFormsOverviewComponent;

  @ViewChild('loadTemplateDialog')
  public dialog: DialogComponent;

  @ViewChild('configTemplateOverview')
  public configTemplateOverview: ConfigurationTemplatesOverviewComponent;

  private isDataValid = true;
  public TransferType = ExportInterfaceConfigurationTransferType;
  public showFilter = false;

  public filterForm = this.fb.group({
    searchText: [null],
    countryCodes: [null],
    salesPersonCodes: [null],
    transferType: [null],
  })

  public get selectedClient(): ClientDTO {
    return this.configurationsService.selectedClient;
  }

  public set selectedClient(value: ClientDTO) {
    if (this.configurationsService.selectedClient != value) {
      //TODO implement message on leaving without saving when selecting new company

      // if (this.configurationFormCoordinatorService.isFormDirty()) {
      //   const dialog = this.modalService.showOkCancelDialog('i18n.domain.export-configuration.configurations.discard-dialog.title', 'i18n.domain.export-configuration.configurations.discard-dialog.question');
      //   dialog.onOkSubject.subscribe(() => {
      //     this.configurationsService.selectedClient = value;
      //     this.configurationFormCoordinatorService.configurationDetailsDTO = null;
      //     this.configurationFormCoordinatorService.resetForms();
      //     this.configurationOverviewComponent.refresh();
      //   });
      // } else {
      //   this.configurationsService.selectedClient = value;
      //   this.configurationFormCoordinatorService.configurationDetailsDTO = null;
      //   this.configurationFormCoordinatorService.resetForms();
      //   this.configurationOverviewComponent.refresh();
      // }

      this.configurationsService.selectedClient = value;
      this.configurationFormCoordinatorService.configurationDetailsDTO = null;
      this.configurationFormCoordinatorService.resetForms();
      this.configurationOverviewComponent.refresh();
    }
  }

  public get selectedCountries(): string[] {
    return this.filterForm.get('countryCodes').value;
  }

  public set selectedCountries(value: string[]) {
    this.filterForm.get('countryCodes').setValue(value);
  }

  public get selectedSalesPersonCodes(): string[] {
    return this.filterForm.get('salesPersonCodes').value;
  }

  public set selectedSalesPersonCodes(value: string[]) {
    this.filterForm.get('salesPersonCodes').setValue(value);
  }

  public get configuration(): ExportInterfaceConfigurationDTO {
    return this.configurationFormCoordinatorService.configurationDetailsDTO;
  }

  public get configurationFormGeneral(): UntypedFormGroup {
    return this.configurationFormCoordinatorService.configurationFormGeneral;
  }

  public get configurationFormTimeplan(): UntypedFormGroup {
    return this.configurationFormCoordinatorService.configurationFormTimeplan;
  }

  public get configurationFormEmail(): UntypedFormGroup {
    return this.configurationFormCoordinatorService.configurationFormEmail;
  }

  public get configurationFormFTP(): UntypedFormGroup {
    return this.configurationFormCoordinatorService.configurationFormFTP;
  }

  public get configurationFormREST(): UntypedFormGroup {
    return this.configurationFormCoordinatorService.configurationFormREST;
  }

  public get configurationFormFileName(): UntypedFormGroup {
    return this.configurationFormCoordinatorService.configurationFormFileName;
  }

  public get configurationFormFileFilter(): UntypedFormGroup {
    return this.configurationFormCoordinatorService.configurationFormFileFilter;
  }

  public get configurationFormFileFields(): UntypedFormGroup {
    return this.configurationFormCoordinatorService.configurationFormFileFields;
  }

  public selectedTemplate: ExportInterfaceConfigTemplateDTO;
  public countries: MultiSelectItem[] = [];
  public multiSelectItemFilter = MultiSelectFilterType.MultiSelectItem;
  public selectedConfigId : number = null;

  private unsubscribe$ = new Subject();

  constructor(
    public configurationFormCoordinatorService: ConfigurationFormCoordinatorService,
    public authService: AuthService,
    public configurationsService: ConfigurationsService,
    private salesPersonCodeClient: SalesPersonCodeClient,
    private translate: TranslateService,
    private configurationTemplateService: ConfigurationTemplatesService,
    private fb: UntypedFormBuilder,
    private toastService: ToastService,
    private modalService: ModalService,
    private spinnerService: SpinnerService,
    private router: Router) {
  }

  ngOnInit() {
    this.configurationsService.importConfigurationId = null;
    this.configurationFormCoordinatorService.configurationDetailsDTO = null;
    this.configurationFormCoordinatorService.resetForms();
    this.configurationFormCoordinatorService.isTemplateMode = false;

    this.translate.onLangChange.pipe(startWith(this.translate.currentLang)).subscribe(() => {
      this.countries = [];
      for (const country in CountryISO2) {
        this.countries.push({ name: this.translate.instant('i18n.shared.CountryISO2.' + country), id: country });
      }
    });

    this.filterForm.valueChanges.pipe(takeUntil(this.unsubscribe$))
      .subscribe(value => {
        this.configurationsService.filterForm = value;
        this.configurationFormCoordinatorService.configurationDetailsDTO = null;
        this.configurationFormCoordinatorService.resetForms();
        this.configurationOverviewComponent.refresh();
    });

    this.router.events.pipe(filter(event => event instanceof NavigationEnd && event.url.includes(configurationsExpConfRoute))).subscribe(() => {
      this.urlChanged();
    });

    // call the first time urlChanged on our own
    this.urlChanged();
  }

  public ngOnDestroy(): void {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
    this.configurationsService.filterForm = null;
    this.configurationsService.configurationType = null;
  }

  public isExecutionPossible(): boolean {
    return this.configurationFormGeneral.get('type').value !== ExportInterfaceConfigurationType.CustomerConnection;
  }

  public urlChanged(): void {
    this.selectedConfigId = UrlHelper.getIdForSegment(pages.configurationsPageName, this.router);
  }

  public onSearchTextChanged(searchText: string): void {
    this.filterForm.get('searchText').setValue(searchText);
  }

  public exportConfigurationsAsCSV(): void {
    const filterDTO = new ExportInterfaceConfigurationFilterDTO({
      clientId: this.selectedClient?.id,
      searchText: this.filterForm.value.searchText,
      salesPersonCodes: this.filterForm.value.salesPersonCodes,
      countryCodes: this.filterForm.value.countryCodes,
      transferType: this.filterForm.value.transferType,
    });

    this.configurationsService.exportConfigurationsAsCSV(filterDTO)
      .subscribe(data => {
        const link = this.createInvisibleDownloadLink(data.csvData, `configuration_list_${DateTime.now().toFormat('yyyyMMddHHmmss')}.csv`);
        link.click();
        link.remove();
      })
  }

  public exportInterfaceConfigurationSelected(selectedExportInterfaceConfiguration: ExportInterfaceConfigurationDTO) {
    if (selectedExportInterfaceConfiguration?.id != this.selectedConfigId) {
      if (selectedExportInterfaceConfiguration.id != null) {
        this.router.navigate([configurationsExpConfRoute + "/" + selectedExportInterfaceConfiguration.id]).then(() => {
          this.configurationFormsOverviewComponent.getUrlRoute();
        });
      } else {
        this.router.navigate([configurationsExpConfRoute]);
      }
    }
    this.configurationFormCoordinatorService.loadConfigurationDetails(selectedExportInterfaceConfiguration.id);
  }

  public onSave() {
    this.saveConfiguration().subscribe({
      next: () => {
      },
      error: () => {
        // we just catch since warnings are handled in service
      }
    });
  }

  public onSaveAndExecute() {
    this.spinnerService.show();
    this.saveConfiguration().pipe(
      switchMap(data => {
        if (!data) {
          this.spinnerService.hide();
          return of();
        }
        return this.configurationsService.executeExportInterfaceConfiguration(data.id).pipe(
          tap(() => {
            this.toastService.showSuccess(
              'i18n.domain.export-configuration.configurations.messages.execute.success-title',
              'i18n.domain.export-configuration.configurations.messages.execute.success-message',
            );
          }),
          catchError((error: any) => {
            if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
              this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError, error.response);
            }
            return throwError(() => error);
          }),
        );
      }),
    ).subscribe({
      next: () => {
        this.spinnerService.hide();
      },
      error: (error) => {
        this.spinnerService.hide();
        // we just catch since warnings are handled in service
      }
    });
  }

  public addConfiguration() {
    if (!this.selectedClient) {
      return;
    }
    this.configurationsService.addRecord().subscribe((data) => {
      this.configurationOverviewComponent.recordAdded(data.id);
    });
  }

  public closeForm() {
    this.configurationFormCoordinatorService.configurationDetailsDTO = null;
    this.configurationOverviewComponent.resetRowSelected();
    this.router.navigate([configurationsExpConfRoute]);
    this.configurationFormCoordinatorService.resetForms();
  }

  public checkShowDeleteTooltip(args): void {
    if (!this.configuration.active) {
      args.cancel = true;
    }
  }

  public deleteConfiguration() {
    const dialog = this.modalService.showOkCancelDialog('i18n.domain.export-configuration.configurations.delete-dialog.title', 'i18n.domain.export-configuration.configurations.delete-dialog.question');
    dialog.onOkSubject.subscribe(() => {
      this.configurationsService.deleteRecord(this.configuration.id).subscribe(data => {
        this.configurationOverviewComponent.refresh();
      });
      this.closeForm();
    });
  }

  public validateWholeForm() {
    let optionalFormsValid = true;
    this.configurationFormCoordinatorService.isWholeFormValid = false;
    let ignoreFileTabs = false;

    //Email
    if (this.configurationFormGeneral.get('transferType').value === ExportInterfaceConfigurationTransferType.Email 
    && this.configurationFormGeneral.get('type').value !== ExportInterfaceConfigurationType.CustomerConnection) {
      optionalFormsValid = optionalFormsValid &&  (this.configurationFormEmail.valid && this.configurationFormTimeplan.valid)
    }
    //SFTPServer
    if (this.configurationFormGeneral.get('transferType').value === ExportInterfaceConfigurationTransferType.SFTPServer) {
      optionalFormsValid = optionalFormsValid && this.configurationFormTimeplan.valid
    }
    //FTPClient
    if (this.configurationFormGeneral.get('transferType').value === ExportInterfaceConfigurationTransferType.FTPClient) {
      optionalFormsValid = optionalFormsValid && (this.configurationFormFTP.valid && this.configurationFormTimeplan.valid)
    }
    //REST
    if (this.configurationFormGeneral.get('transferType').value === ExportInterfaceConfigurationTransferType.REST) {
      optionalFormsValid = optionalFormsValid && (this.configurationFormREST.valid)
    }
    //SFTPServerOnly
    if (this.configurationFormGeneral.get('transferType').value === ExportInterfaceConfigurationTransferType.SFTPServerOnly) {
      ignoreFileTabs = true;
    }

    if (this.configurationFormGeneral.get('type').value === ExportInterfaceConfigurationType.CustomerBacklog) {
      optionalFormsValid = optionalFormsValid && this.configurationFormCoordinatorService.configurationFormBacklog.valid;
    }

    if (this.configurationFormGeneral.get('type').value === ExportInterfaceConfigurationType.Finance) {
      optionalFormsValid = optionalFormsValid && this.configurationFormCoordinatorService.configurationFormFinance.valid;
    }

    if (this.configurationFormGeneral.get('type').value === ExportInterfaceConfigurationType.EDIOrder
      || this.configurationFormGeneral.get('type').value === ExportInterfaceConfigurationType.XMLOrder
      || this.configurationFormGeneral.get('type').value === ExportInterfaceConfigurationType.CustomerConnection
      || this.configurationFormGeneral.get('transferType').value === ExportInterfaceConfigurationTransferType.AS2
      || this.configurationFormGeneral.get('type').value === ExportInterfaceConfigurationType.ProductCatalog) {
      ignoreFileTabs = true;
    }

    if (this.configurationFormGeneral.valid
      && (ignoreFileTabs || this.configurationFormFileName.valid && this.configurationFormFileFilter.valid &&
        (this.configurationFormFileName.get('processType').value === ExportInterfaceConfigurationFileProcessType.ColumnBased && this.configurationFormFileFields.valid) ||
        this.configurationFormFileName.get('processType').value === ExportInterfaceConfigurationFileProcessType.LineBased && this.configurationFormCoordinatorService.configurationFormFileLineBasedAllAttributes.valid)
      && optionalFormsValid) {
      this.configurationFormCoordinatorService.isWholeFormValid = true;
    }
  }

  public validateData(data: UpdateExportInterfaceConfigurationDTO) {
    if ((data.configurationDetails.transferType == ExportInterfaceConfigurationTransferType.Email
      || data.configurationDetails.transferType == ExportInterfaceConfigurationTransferType.SFTPServer
      || data.configurationDetails.transferType == ExportInterfaceConfigurationTransferType.SFTPServerOnly)
      && data.configurationDetails.active == true
      && data.configurationDetails.type !== ExportInterfaceConfigurationType.EDIOrder
      && data.configurationDetails.type !== ExportInterfaceConfigurationType.XMLOrder
      && data.configurationDetails.type !== ExportInterfaceConfigurationType.ProductCatalog) {
      let atleastOneUserHasAccess = false;
      if (data.configurationDetails.userAccessList) {
        atleastOneUserHasAccess = data.configurationDetails.userAccessList.some((ua) => ua.hasAccess);
      }
      if (!atleastOneUserHasAccess) {
        this.isDataValid = false;
        this.toastService.showWarning('i18n.domain.export-configuration.configurations.messages.data-invalid.title',
          'i18n.domain.export-configuration.configurations.messages.data-invalid.no-user-access', null);
      }
    }
  }

  public getCountries(searchText: string): Observable<MultiSelectItem[]> {
    return of(this.countries.filter(country => country.name.toLowerCase().includes(searchText?.toLowerCase())));
  }

  public getSalesPersonCodes(searchText: string): Observable<string[]> {
    return this.salesPersonCodeClient.searchSalesPersonCodes(15, searchText);
  }

  //Dialog Methods
  public loadFromTemplate() {
    this.dialog.show();
    this.configTemplateOverview.refresh();
  }

  public cancelClicked() {
    this.selectedTemplate = null;
    this.dialog.hide();
  }

  public okClicked() {
    if (this.selectedTemplate) {
      this.configurationTemplateService.getConfigurationDetails(this.selectedTemplate.id).subscribe((configurationDetailsDto: ExportInterfaceConfigurationDetailsDTO) => {
        this.configurationFormCoordinatorService.loadFromTemplate(configurationDetailsDto);
      });

    }
    this.selectedTemplate = null;
    this.dialog.hide();
  }

  public templateSelected(selectedConfigurationTemplate: ExportInterfaceConfigTemplateDTO) {
    this.selectedTemplate = selectedConfigurationTemplate;
  }

  public templateSelectedAndClose(selectedConfigurationTemplate: ExportInterfaceConfigTemplateDTO) {
    this.selectedTemplate = selectedConfigurationTemplate;
    this.okClicked();
  }

  public onOpen(args: any): void {
    //Preventing the default dialog focus
    args.preventFocus = true;
  }

  private saveConfiguration(): Observable<ExportInterfaceConfigurationDTO> {
    this.validateWholeForm();
    if (this.configurationFormCoordinatorService.isWholeFormValid) {
      var formData = this.getUpdateDTOFromFormData();
      this.isDataValid = true;
      this.validateData(formData);
      if (this.isDataValid) {
        return this.configurationsService.updateRecord(formData).pipe(
          tap(data => {
            this.closeForm();
            this.configurationOverviewComponent.refresh();
          }),
        );
      }
      else {
        return of(null);
      }
    } else {
      if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
        this.toastService.showWarning('i18n.domain.export-configuration.configurations.messages.form-invalid.title',
          'i18n.domain.export-configuration.configurations.messages.form-invalid.message', null);
      }
      return of(null);
    }
  }

  private getUpdateDTOFromFormData(): UpdateExportInterfaceConfigurationDTO {
    return new UpdateExportInterfaceConfigurationDTO({
      configurationDetails: this.configurationFormCoordinatorService.createConfigurationDetailsDTOFromForm(),
    });
  }

  private createInvisibleDownloadLink(data: string, filename: string): HTMLAnchorElement {
    const blob = new Blob([data], { type: 'csv/text' });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    return link;
  }

  canDeactivate(): Observable<boolean> | boolean {
    if (this.configurationFormCoordinatorService.isFormDirty()) {
      const dialog = this.modalService.showOkCancelDialog('i18n.domain.export-configuration.configurations.discard-dialog.title', 'i18n.domain.export-configuration.configurations.discard-dialog.question');
      return merge(
        dialog.onOkSubject.pipe(mapTo(true)),
        dialog.onCancelSubject.pipe(mapTo(false)),
      );
    }
    return true;
  }

}
